export default __webpack_public_path__ + "static/media/watermark.8fe812b8.png";